import React from "react";
import get from "lodash.get";
import GeneralAction from "components/General/GeneralAction";

const BADGE_STEP = 0.46;

const HorizontalBadges = (props: any) => {
  const badges = get(props, "badges", []);
  const height = get(props, "height", "7vh");
  const badgeList = badges && Array.isArray(badges) ? badges : [];
  const badgesCount = badgeList.length;
  const mappedBadges = badgeList.map((e: any, i: number) => {
    return (
      <img
        key={i}
        style={{
          position: "absolute",
          top: 0,
          left: `calc(${height} * ${i * BADGE_STEP})`,
          height: "100%",
          width: "auto",
          zIndex: i,
        }}
        src={e.logo}
        alt={"Badge"}
        onClick={GeneralAction}
      ></img>
    );
  });
  const widthFactor = badgesCount > 0 ? 1 + (badgesCount - 1) * BADGE_STEP : 1;

  return (
    <div
      className="relative"
      style={{
        height,
        width: `calc(${height} * ${widthFactor})`,
        flex: "0 0 auto",
      }}
    >
      {mappedBadges}
    </div>
  );
};

export default HorizontalBadges;
